import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Modal } from './modal';
import ModalFooter from './ModalFooter';
import Typography from './Typography';
import vmTheme from '../constants/theme';
import { font } from '../constants/font';
import { STATIC_PATH } from '../constants/config';

const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 32px;
`;

const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
`;

const ErrorModal = ({
  title,
  message,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  onCloseModal,
  primaryButtonColor,
  secondaryButtonColor,
  width = '424px',
  showBackdrop = true,
}) => {
  const theme = useSelector((state) => state.app.get("theme"));

  return (
    <Modal
      showModal={true}
      useWrapper={false}
      onClose={() => onCloseModal?.()}
      borderRadius="16px"
      width={width}
      preventEscClose={true}
      showBackdrop={showBackdrop}
      height="auto"
    >
      <ErrorWrapper>
        <IconContainer>
          <img src={`${STATIC_PATH}vm-error-info.svg`} alt="error-icon" />
        </IconContainer>

        <ContentContainer>
          {title && (
            <Typography
              content={title}
              color={vmTheme[theme].panelPrimaryColor}
              font={font.bold_16}
              align="center"
              enableTrim={false}
            />
          )}
          {message && (
            <Typography
              content={message}
              color={vmTheme[theme].panelSecondaryColor}
              font={font.normal14}
              align="center"
              enableTrim={false}
            />
          )}
        </ContentContainer>

        <ModalFooter
          onSave={onPrimaryButtonClick}
          confirmText={primaryButtonText}
          cancelText={secondaryButtonText}
          onClose={onSecondaryButtonClick}
          backgroundColor={primaryButtonColor || vmTheme[theme].secondaryBorderColor}
          fontsColor={vmTheme[theme].polarColor}
          cancelBackground={secondaryButtonColor || vmTheme[theme].btnBgLightColor}
          justifyContent="center"
          padding="0px"
        />
      </ErrorWrapper>
    </Modal>
  );
};

ErrorModal.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  primaryButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func,
  onSecondaryButtonClick: PropTypes.func,
  onCloseModal: PropTypes.func,
  primaryButtonColor: PropTypes.string,
  secondaryButtonColor: PropTypes.string,
  width: PropTypes.string,
  showBackdrop: PropTypes.bool,
};

export default ErrorModal;
